document.getElementById("copy_code").addEventListener("click", function () {
  // Discount code ko copy karne ke liye
  let discountCode = document.getElementById("discount_code").innerText;

  // Clipboard me copy karne ke liye
  navigator.clipboard
    .writeText(discountCode)
    .then(function () {
      alert("Discount Code Copied: " + discountCode);
    })
    .catch(function (err) {
      console.error("Failed to copy: ", err);
    });
});
